import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document, INLINES } from '@contentful/rich-text-types';
import BlogTextAndImage from './BlogTextAndImage';
import ImageStack from './ImageStack';
import {
  Eyebrow,
  Header1,
  Header2,
  Header3,
  Header4,
  Header5,
  LinkWrapper,
  Ol,
  Paragraph,
  Quote,
  RichTextWrapper,
  Ul,
} from './styles';
import { ReactNode } from 'react';

const options = {
  renderNode: {
    [BLOCKS.HEADING_1]: (node, children) => <Header1>{children}</Header1>,
    [BLOCKS.HEADING_2]: (node, children) => <Header2>{children}</Header2>,
    [BLOCKS.HEADING_3]: (node, children) => <Header3>{children}</Header3>,
    [BLOCKS.HEADING_4]: (node, children) => <Header4>{children}</Header4>,
    [BLOCKS.HEADING_5]: (node, children) => <Header5>{children}</Header5>,
    [BLOCKS.HEADING_6]: (node, children) => <Eyebrow>{children}</Eyebrow>,
    [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
    [BLOCKS.UL_LIST]: (node, children) => <Ul>{children}</Ul>,
    [BLOCKS.OL_LIST]: (node, children) => <Ol>{children}</Ol>,
    [BLOCKS.QUOTE]: (node, children) => <Quote>{children}</Quote>,
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      if (node?.data?.target?.sys?.contentType?.sys?.id === 'blogTextAndImage') {
        return (
          <BlogTextAndImage
            header={node?.data?.target?.fields?.header}
            richText={node?.data?.target?.fields?.richText}
            imgFocalPoint={node?.data?.target?.fields?.imgFocalPoint}
            reverse={node?.data?.target?.fields?.reverse}
          />
        );
      } else if (node?.data?.target?.sys?.contentType?.sys?.id === 'imageStack') {
        return <ImageStack imgs={node?.data?.target?.fields?.imgs} />;
      }
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => (
      <img src={node?.data?.target?.fields?.file?.url} alt="My image alt text" />
    ),
    [INLINES.HYPERLINK]: (node, children) => (
      <LinkWrapper>
        <a href={node.data.uri}>{children}</a>
      </LinkWrapper>
    ),
  },
  renderText: (text) => text.split('\n').flatMap((text, i) => [i > 0 && <br key={i} />, text]),
};

const Text = ({ children }) => <Paragraph>{children}</Paragraph>;

const RichText = ({
  richText,
  dataTestId,
}: {
  richText: Document;
  dataTestId?: string;
}): ReactNode => {
  return (
    <RichTextWrapper data-testid={dataTestId}>
      {documentToReactComponents(richText, options)}
    </RichTextWrapper>
  );
};

export default RichText;
